export const getWheatPastaPackage = newProduct => {
  const newWheatPastaPackage = {
    UPC: newProduct.UPC,
    WholeWheatFlour: newProduct.WholeWheatFlour,
    PastaShape: newProduct.PastaShape,
    Size: newProduct.Size,
  }
  return newWheatPastaPackage
}

export const updateWheatPastaPackage = newProduct => {
  const newWheatPastaPackage = {
    UPC: newProduct.UPC,
    WholeWheatFlour: newProduct.WholeWheatFlour,
    PastaShape: newProduct.PastaShape,
    Size: newProduct.Size,
  }
  return newWheatPastaPackage
}
